import clsx from 'clsx';
import { CSSProperties, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Link } from '.';

export type ButtonUnstyledProps = {
  className?: string;
  to?: string;
  target?: string;
  disabled?: boolean;
  onClick?: (e: any) => void;
  download?: string;
  style?: CSSProperties;
} & Omit<React.ComponentPropsWithRef<'button'>, 'onClick'>;

const ButtonUnstyled = (
  { children, className, to = '', target, disabled, onClick, ...props }: ButtonUnstyledProps,
  ref,
) => {
  const El = to ? Link : 'button';
  return (
    <El
      className={twMerge(
        clsx(
          'bg-transparent border-none cursor-pointer pb-0 px-0 text-[currentcolor] inline-block box-border active:underline focus:underline hover:underline',
          className,
        ),
      )}
      ref={ref}
      to={to}
      target={target}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </El>
  );
};

export default forwardRef(ButtonUnstyled);
